import { loadClerkSession } from './loadClerkSession';
import { hasClerkClientSession } from './useAuth.helpers';
import type { AuthSession } from './types';

type GetTokenFn = (options?: { skipCache?: boolean }) => Promise<string | null>;

export const resolveClerkSignedInSignal = (input: {
  isSignedIn: boolean | null | undefined;
  client: unknown;
}): boolean => {
  if (input.isSignedIn === true) {
    return true;
  }
  return hasClerkClientSession(input.client);
};

export const loadCurrentClerkSessionFromState = async (input: {
  client: unknown;
  getToken: GetTokenFn;
  currentUserId: string | null;
  allowProvisioning: boolean;
  forceTokenRefresh?: boolean;
  bootstrapSession: (
    accessToken: string,
    opts?: { allowProvisioning?: boolean },
  ) => Promise<AuthSession>;
  clearProvisioningFlag: () => void;
}): Promise<AuthSession | null> => {
  return await loadClerkSession({
    client: input.client,
    getToken: input.getToken,
    currentUserId: input.currentUserId,
    allowProvisioning: input.allowProvisioning,
    forceTokenRefresh: input.forceTokenRefresh === true,
    bootstrapSession: input.bootstrapSession,
    clearProvisioningFlag: input.clearProvisioningFlag,
  });
};
